__turbopack_context__.v({
  "divider": "styles-module__9j7MLG__divider",
});
